"use client";

import Image from "next/image";
import Reveal from "../../enterprise/components/Reveal";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { useTranslations } from "next-intl";
import "swiper/css";

export default function RuntimeLayerSection() {
  const t = useTranslations("user");

  const cardData = [
    {
      id: 1,
      title: t("compiles-ai-models-into-circuits"),
      subtitle: t("compile_ai_models_into_secure_verifiable_circuits_for_trustless_web3_integration"),
      imgUrl: "/images/backgrounds/ai-user.svg",
    },
    {
      id: 2,
      title: t("zk-stark-proofs-of-correctness"),
      subtitle: t("leverages_cutting_edge_zk_stark_technology_to_produce_tamper_proof_proofs"),
      imgUrl: "/images/backgrounds/search-user.svg",
    },
    {
      id: 3,
      title: t("independently-verification"),
      subtitle: t("check_the_accuracy_of_ai_results_without_compromising_privacy"),
      imgUrl: "/images/backgrounds/security-user.svg",
    },
  ];

  return (
    <section
      id="ZKML-user"
      className="mx-auto w-full max-w-[1440px] overflow-hidden px-20 py-[120px] max-lg:px-10 max-sm:px-4"
    >
      <div className="flex flex-col items-center justify-center">
        <Reveal
          delay={0.1}
          duration={0.8}
          direction="left"
          withBlur={true}
          blurAmount={8}
        >
          <h2 className="text-center text-[48px]/[56px] font-normal tracking-[-1px] text-black max-lg:text-[32px]/[40px]">
            ZKML runtime layer
          </h2>
        </Reveal>
        <Reveal
          delay={0.5}
          duration={0.8}
          direction="left"
          withBlur={true}
          blurAmount={8}
        >
          <p className="mt-5 max-w-[612px] text-center text-base font-light text-[#202020] opacity-[0.8] max-lg:text-sm">
            {t(
              "hyra-uses-zkml-to-make-ai-verifiable-private-and-efficient-protecting-sensitive-data-across-federated-environments",
            )}
          </p>
        </Reveal>
      </div>
      {/* desktop */}
      <div className="mt-[56px] grid grid-cols-3 gap-6 max-lg:hidden">
        {cardData.map((card, index) => (
          <motion.div
            initial={{ opacity: 0, translateY: 40 }}
            whileInView={{ opacity: 1, translateY: 0 }}
            transition={{ delay: index * 0.2, duration: 1, ease: "easeOut" }}
            viewport={{ once: true }}
            key={card.id}
          >
            <div className="flex h-full flex-col items-start justify-start gap-6 rounded-[12px] border-[2px] border-[#0066FF0F] p-6 shadow-[0_0_20px_rgba(0,0,0,0.04)]">
              <p className="text-[32px]/[40px] font-normal">{card.title}</p>
              <Image
                src={card.imgUrl}
                alt={card.title}
                width={200}
                height={200}
                className="h-[218px] w-auto rounded-[12px]"
              />
              <p className="text-base text-[#646464]">{card.subtitle}</p>
            </div>
          </motion.div>
        ))}
      </div>

      {/* tablet */}
      <div className="mt-[56px] hidden w-full max-lg:block max-sm:hidden">
        <Swiper
          spaceBetween={16}
          slidesPerView={"auto"}
          freeMode={true}
          className="!overflow-visible"
        >
          {cardData.map((card, index) => (
            <SwiperSlide
              key={index}
              className="flex !h-auto max-w-[277px] flex-col items-start justify-start gap-6 rounded-[12px] border-[2px] border-[#0066FF0F] p-6 shadow-[0_0_20px_rgba(0,0,0,0.04)]"
            >
              <div className="flex h-full flex-col justify-between">
                <div>
                  <p className="text-[22px]/[30px] font-normal">{card.title}</p>
                  <Image
                    src={card.imgUrl}
                    alt={card.title}
                    width={200}
                    height={200}
                    className="h-[218px] w-auto rounded-[12px]"
                  />
                </div>
                <p className="text-sm text-[#646464]">{card.subtitle}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* mobile */}
      <div className="mt-[56px] hidden grid-rows-3 gap-6 max-sm:grid">
        {cardData.map((card, index) => (
          <motion.div
            initial={{ opacity: 0, translateY: 40 }}
            whileInView={{ opacity: 1, translateY: 0 }}
            transition={{ delay: index * 0.2, duration: 1, ease: "easeOut" }}
            viewport={{ once: true }}
            key={card.id}
          >
            <div className="flex flex-col items-start justify-start gap-6 rounded-[12px] border-[2px] border-[#0066FF0F] p-6 shadow-[0_0_20px_rgba(0,0,0,0.04)]">
              <p className="text-[22px]/[30px] font-normal">{card.title}</p>
              <Image
                src={card.imgUrl}
                alt={card.title}
                width={200}
                height={200}
                className="h-[218px] w-auto rounded-[12px]"
              />
              <p className="text-sm font-light text-[#646464]">
                {card.subtitle}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
